<form>
  <app-input [formControl]="form.controls.name"
             [placeholder]="'Plan name'"
             [showErrors]="showErrors">
  </app-input>
  <app-textarea class="description"
                [formControl]="form.controls.description"
                [placeholder]="'Description'"
                [showErrors]="showErrors">
  </app-textarea>
    <!--<app-input-switch [(ngModel)]="hasDocuments"
                     name="hasDocuments"
                     onLabel="Document with working instructions available">
   </app-input-switch>
   <br>
  <app-file-input *ngIf="hasDocuments"
                   [acceptedTypes]="'.doc,.pdf,.docx,.xlx,.xlxs,.step,.dwg,image/*'"
                   [required]="hasDocuments"
                   (onFileUpload)="selectFiles($event)"
                   (onFilesSelected)="selectFiles($event)"
                   (onFileRemoved)="selectFiles($event)">
   </app-file-input> -->
</form>
